<template>
   <section id="manage-workspace">
     <div class="contenedor">
  		<div class="row">
       		<div class="col-12">
  				<strong class="mb-1">{{project.email_owner}}</strong>
       		</div>
		 			<div v-if="urlauth" class="p-4">
		 					<a :href="urlauth" class="text-primary my-4" target="_blank">Reauthentication needed</a>
		 			</div>
       		<div v-if="!urlauth">
       		<div class="col-12" v-if="userres.users !== undefined && !loading">
  				Current users:
       			<span v-if="userres.users.length >= getLimitUser()" class="badge-danger badge">{{userres.users.length}}</span>
       			<span v-else class="badge-success badge">{{userres.users.length}}</span> <small>(Limit: {{getLimitUser()}} users)</small>
       		</div>
       	<div class="col-12 mt-2">
       		<span v-if="domaintobuy.length == 0">No domains to buy</span>
       	</div>
  			<div class="col-12" v-if="!loading && userres.users.length < getLimitUser() && domaintobuy.length > 0">
  				<h6>Sufix</h6>
  				<strong>the system will try to buy with each prefix until it finds some available domain.</strong>
       			<input @input="keytext++" type="text" v-model="prefix" size="80"></input>
       		</div>
       		<div class="col-12" :ref="keytext"  v-if="domaintobuy.length > 0 && userres.users !== undefined && !loading && userres.users.length < getLimitUser()">
       			<ul class="mt-2">
       				<li v-for="(domain,key) in domains">
       				<Fieldset :title="domain.name" :mykey="key" 
       				:classButton="domain.is_replace == 1 ? '':'btn text-white'"
       				:customClass="domain.is_replace == 1 ? 'bg-none':'bg-white'">
       					<BuyDomain :domain="domain" :prefix="prefix" :project="project"></BuyDomain>
       				</Fieldset>
       				</li> 
       			</ul>
       		</div>
       		</div>
       		<span  v-if="loading" class="loadingres spinner-border loading-spinner ml-2"></span>
       	</div>
       	</div>
   </section>
</template>
<script>


import { mapState,mapMutations  } from "vuex";
import BuyDomain from "@/components/Workspace/BuyDomain.vue";
import Fieldset from "@/components/Common/Fieldset.vue";

import {
  workspaceService
} from "@/_services";

export default {
    props: {
    	project: false,
    },
	data() {
		return {
			keytext:2323223,
			urlauth:false,
	    	loading:false,
	    	buying:false,
	    	domains:[],
	    	domaintobuy:[],
	    	userres:[],
		  prefix: ",get,try,join,gofor,start,use,hire,launch,meet,discover,find,explore,growwith,your,workwith,my,connect,team,hello,partner,signup,startwith,build,joinus,experience,go,engage,access,workwithus,partnerwith,unlock,scale,choose,optimize,innovate,create,lead,follow,activate,empower,thrivewith,connectwith,boost,reach,succeedwith,elevate,achieve,discoverwith,accelerate,empowerwith",
	    }
	},
	  components: {
	  	BuyDomain,
	  	Fieldset
	  },
	created(){
		this.loading = true;

		
		workspaceService.getDomainsToBuy().then(result => {
			this.domains = result
			this.recalculate()
		})
		if(this.project && this.project.id){
			workspaceService.getWorkspaceUsers(this.project.id).then(result => {
				this.loading = false
				if(result.users == undefined){
				  this.urlauth = result
				}else{
					this.userres = result
				}
			})
		}else{
		  //OUTLOOK
			workspaceService.getWorkspaceUsers(999).then(result => {
				this.loading = false
				if(result == undefined){
				  this.urlauth.users = result
				}else{
					this.userres.users = result
				}
			})
		}
	},
    methods:{
      recalculate(){
        let domainname
				this.domains.forEach(domain => {
					domainname = this.getDomainProcessed(domain.name)
					this.domaintobuy.push(domainname)
					this.loading = false
				})
      },
      getLimitUser(){
      	if(!this.project){
      		return 90000
      	}

      	if(this.project.id == 9 || this.project.id == 12){
      		return 50
      	} 
      	return 280
      },
      recalculatedom(key,domainname){
				domainname = this.getDomainProcessed(domainname)
				this.domaintobuy[key] = domainname
      },
	  	getDomainProcessed(domain){
		  	domain = domain.replace(/\s/g, '');
			  domain = domain.toLowerCase();
		  	return domain
		  }
    },
    computed: {
	  ...mapState({
	      isMenuCollapse: state => state.sidebar.isNavOpen,
	  }),
    }
}
</script>